// Library imports
import React from 'react';
import { array, bool, func, shape, string } from 'prop-types';
// Component imports
import TabNav from '../TabNav';
// Styled Components
import { CardTitle, HighLightedField, TeamLogoSmall } from '../GameCard/windows/styles';
import { CompareListCol } from './styles';
// Util imports
import useScreenWidth from '../../utils/hooks/useScreenWidth';
import { MOBILE_SCREEN_SIZE } from '../../utils/constants';
import { MDBRow } from 'mdb-react-ui-kit';
import { imageLoadError } from '../../utils';

const CompareList = ({
    labels = [],
    dataSetOne = [],
    dataSetOneTitle = '',
    dataSetOneTitleColor = '#000',
    dataSetOneLogo = '',
    dataSetTwo = [],
    dataSetTwoTitle = '',
    dataSetTwoTitleColor = '#000',
    dataSetTwoLogo = '',
    tabs = [],
    activeTabs = {},
    setTabs = () => {},
    loading = false,
}) => {
    const screenWidth = useScreenWidth();

    const normalizeDataSet = (labels, dataSet) => {
        const lookup = dataSet.reduce((acc, item) => {
            acc[item.label] = item;
            return acc;
        }, {});
        return labels.map(label => (lookup[label] ? lookup[label] : { label, value: '---', class: 'light' }));
    };

    const normalizedOne = normalizeDataSet(labels, dataSetOne);
    const normalizedTwo = normalizeDataSet(labels, dataSetTwo);

    const sortedIndices = labels
        .map((label, index) => ({
            label,
            index,
            bothHaveValues: normalizedOne[index].value !== '---' && normalizedTwo[index].value !== '---',
        }))
        .sort((a, b) => {
            if (a.bothHaveValues && !b.bothHaveValues) return -1;
            if (!a.bothHaveValues && b.bothHaveValues) return 1;
            return a.index - b.index;
        });

    const sortedLabels = sortedIndices.map(item => item.label);
    const sortedNormalizedOne = sortedIndices.map(item => normalizedOne[item.index]);
    const sortedNormalizedTwo = sortedIndices.map(item => normalizedTwo[item.index]);

    return (
        <MDBRow className="g-0">
            <CompareListCol size="4">
                <CardTitle color={dataSetOneTitleColor} style={{ padding: 0, marginBottom: '0.75rem' }}>
                    {dataSetOneLogo && <TeamLogoSmall src={dataSetOneLogo} alt="" onError={imageLoadError} />}
                    {dataSetOneTitle}
                </CardTitle>
                {tabs.length ? (
                    <TabNav
                        tabs={tabs}
                        activeTab={activeTabs.type1}
                        setTab={tab => setTabs({ ...activeTabs, type1: tab })}
                        containerStyle={{ marginBottom: '1rem' }}
                        textStyle={{ fontSize: '0.65rem', padding: screenWidth < MOBILE_SCREEN_SIZE ? '0.25rem 0.25rem' : '0.25rem 0.5rem' }}
                        disabled={loading}
                    />
                ) : null}
                {sortedNormalizedOne.map((value, i) => {
                    const fieldClass = value.class !== undefined ? value.class : 'light';
                    const fieldValue = value.value !== undefined ? value.value : value;
                    return (
                        <HighLightedField key={i} className="data-value" variant={fieldClass} style={{ marginBottom: '3px' }}>
                            {fieldValue}
                        </HighLightedField>
                    );
                })}
            </CompareListCol>
            <CompareListCol size="4">
                <CardTitle color={dataSetOneTitleColor} style={{ padding: 0, marginBottom: tabs.length ? '2.9629rem' : '0.75rem', visibility: 'hidden' }}>
                    filter
                </CardTitle>
                {sortedLabels.map((value, i) => {
                    return (
                        <HighLightedField key={i} variant="light" style={{ marginBottom: '3px', backgroundColor: 'transparent' }}>
                            {value}
                        </HighLightedField>
                    );
                })}
            </CompareListCol>
            <CompareListCol size="4">
                <CardTitle color={dataSetTwoTitleColor} style={{ alignSelf: 'flex-end', padding: 0, marginBottom: '0.75rem' }}>
                    {dataSetTwoTitle}
                    {dataSetTwoLogo && <TeamLogoSmall src={dataSetTwoLogo} alt="" onError={imageLoadError} />}
                </CardTitle>
                {tabs.length ? (
                    <TabNav
                        tabs={tabs}
                        activeTab={activeTabs.type2}
                        setTab={tab => setTabs({ ...activeTabs, type2: tab })}
                        containerStyle={{ marginBottom: '1rem', justifyContent: 'flex-end' }}
                        textStyle={{ fontSize: '0.65rem', padding: screenWidth < MOBILE_SCREEN_SIZE ? '0.25rem 0.25rem' : '0.25rem 0.5rem' }}
                        disabled={loading}
                    />
                ) : null}
                {sortedNormalizedTwo.map((value, i) => {
                    const fieldClass = value.class !== undefined ? value.class : 'light';
                    const fieldValue = value.value !== undefined ? value.value : value;
                    return (
                        <HighLightedField key={i} variant={fieldClass} style={{ marginBottom: '3px' }}>
                            {fieldValue}
                        </HighLightedField>
                    );
                })}
            </CompareListCol>
        </MDBRow>
    );
};

CompareList.propTypes = {
    labels: array,
    dataSetOne: array,
    dataSetOneTitle: string,
    dataSetOneTitleColor: string,
    dataSetTwo: array,
    dataSetTwoTitle: string,
    dataSetTwoTitleColor: string,
    tabs: array,
    activeTabs: shape({ type1: string, type2: string }),
    setTabs: func,
    loading: bool,
};

export default CompareList;
